import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vconsole from 'vconsole'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vant from 'vant';
import moment from 'moment'
import axios from 'axios'
import Cookie from 'js-cookie'

import 'normalize.css/normalize.css'
import 'minireset.css/minireset.css'
import '@/assets/style/common.scss'
import 'vant/lib/index.css';
process.NODE_ENV === 'test' ? new Vconsole() : ''

Vue.prototype.$moment = moment
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$cookie = Cookie

const messages = ['success', 'warning', 'info', 'error']

messages.forEach(type => {
  ElementUI.Message[type] = options => {
    if (typeof options === 'string') {
      options = {
        message: options
      }
      // 默认配置
      options.showClose = true
    }
    options.type = type
    return ElementUI.Message(options)
  }
})
Vue.use(ElementUI)
Vue.use(Vant)
// 防抖处理btn
Vue.directive('noMoreClick', {
  inserted (el, binding) {
    el.addEventListener('click', (e) => {
      el.classList.add('is-disabled')
      el.disabled = true
      setTimeout(() => {
        el.disabled = false
        el.classList.remove('is-disabled')
      }, 5000)
    })
  }
})
// 防抖处理div
Vue.directive('noMoreDiv', {
  inserted (el, binding) {
    el.addEventListener('click', (e) => {
      el.classList.add('disableMore')
      el.disabled = true
      setTimeout(() => {
        el.disabled = false
        el.classList.remove('disableMore')
      }, 5000)
    })
  }
})

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
